import { useEffect, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import PageHeader from "./-components/PageHeader";
import SelectBox from "../morning/-components/common/SelectBox";
import { formatDateToString, shortcut } from "hooks/utils/util";
import { ConsoleOrderRequest } from "hooks/console/useGetConsoleQuickOrder";
import ConsoleOrderForm, { SearchFormProps } from "./common/ConsoleOrderForm";
import LoadingPop from "components/popup/LoadingPop";
import Pagination from "components/Pagination";
import { docArray, itemTypeArray, kindArray, payGbnArray, sfastArray } from "./ConsoleExpressOrderDetail";
import { useGetConsoleExpressOrder } from "hooks/console/useGetConsoleExpressOrder";
import Seo from "components/Seo";
// import { ReactComponent as PageBefore } from "assets/morning/icon/pageBefore.svg";
// import { ReactComponent as PageFirst } from "assets/morning/icon/pageFirst.svg";

// const maxPage = 1;

const ConsoleExpressOrder = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const initialSearchForm = {
        category: "express",
        user_id: "",
        limit: "10",
        from_date: searchParams?.get("from_date") ? new Date(searchParams.get("from_date") as string) : new Date(),
        to_date: searchParams?.get("to_date") ? new Date(searchParams.get("to_date") as string) : new Date(),
        serial_number: "",
        order_state: "",
        delivery_type: "",
        car_type: "",
        departure_dong_name: "",
        payment_type: "",
        destination_dong_name: "",
    };
    const [page, setPage] = useState<number>(1);
    const [searchForm, setSearchForm] = useState<SearchFormProps>(initialSearchForm); // 입력 중인 값
    const [submittedForm, setSubmittedForm] = useState<ConsoleOrderRequest | null>(null); // 제출된 상태만 API 요청에 사용
    const location = useLocation();
    const { data: orderData, isLoading } = useGetConsoleExpressOrder(submittedForm);
    const { 특송화물인터넷접수 } = shortcut();
    // const maxPage = data?.last_page ?? 1;
    // const pageSize = Number(searchForm.limit);
    // const currentGroup = Math.floor((page - 1) / pageSize);
    // const startPage = currentGroup * pageSize + 1;
    // const endPage = Math.min(startPage + pageSize - 1, maxPage);

    // 사이드바 링크 재 클릭시 상태 초기화
    useEffect(() => {
        if (location.state?.reset) {
            // 초기화 로직 수행
            setSearchForm(initialSearchForm);
            setPage(1);
        }
    }, [location.state]);

    useEffect(() => {
        const page = searchParams.get("page") ?? "1";
        if (page) {
            setSearchForm(prev => ({ ...prev, page: Number(page) }));
        }
    }, [searchParams]);

    // 페이징, 개수 필터 셀렉트 수정시 검색 실행
    useEffect(() => {
        searchHandler();
    }, [page, searchForm.limit]);

    // 검색 버튼 클릭시
    const searchHandler = () => {
        if (searchForm.from_date && searchForm.to_date) {
            const from_date = formatDateToString(searchForm.from_date);
            const to_date = formatDateToString(searchForm.to_date);

            searchParams.set("from_date", from_date);
            searchParams.set("to_date", to_date);

            setSearchParams(searchParams);

            setSubmittedForm({
                ...searchForm,
                page,
                from_date: searchForm.from_date ? from_date : "",
                to_date: searchForm.to_date ? to_date : "",
            });
        }
    };

    // 검색 폼 초기화
    const resetForm = () => {
        setSearchParams({});

        setSearchForm({ ...initialSearchForm, from_date: new Date(), to_date: new Date() });
        setPage(1);
    };

    return (
        <>
            <Seo type="console" pageTitle="특송화물 인터넷접수" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="고객서비스" title="특송화물 인터넷접수" linkTo={특송화물인터넷접수} />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className="px-[40px] py-[28px] w-full overflow-auto">
                        <div className="flex flex-col gap-10 min-w-[1200px]">
                            <ConsoleOrderForm
                                searchForm={searchForm}
                                setSearchForm={setSearchForm}
                                searchHandler={searchHandler}
                                resetForm={resetForm}
                            />
                            <div className="bg-white flex flex-col gap-4 rounded-[20px] py-[24px] px-[40px]">
                                <SelectBox
                                    options={[
                                        { label: "10개", value: "10" },
                                        { label: "20개", value: "20" },
                                    ]}
                                    value={searchForm.limit}
                                    onChange={val => setSearchForm(prev => ({ ...prev, limit: val }))}
                                    height="h-[50px]"
                                    className="w-[160px] !text-[15px] ml-auto"
                                />
                                {isLoading ? (
                                    <LoadingPop />
                                ) : (
                                    <table className="text-[#666] table-fixed w-full">
                                        <colgroup>
                                            <col width="7%" />
                                            <col width="8%" />
                                            <col width="7%" />
                                            <col width="7%" />
                                            <col width="9%" />
                                            <col width="9%" />
                                            <col width="18%" />
                                            <col width="7%" />
                                            <col width="7%" />
                                            <col width="7%" />
                                            <col width="7%" />
                                            <col width="7%" />
                                        </colgroup>

                                        <thead className="bg-[#FBFBFC] h-[90px] border-t-2 border-black border-b w-full">
                                            <tr className="w-full">
                                                <th className="font-[400] border-r border-[#ddd]">접수일</th>
                                                <th className="font-[400] border-r border-[#ddd]">상호</th>
                                                <th className="font-[400]  border-r border-[#ddd]">부서명</th>
                                                <th className="font-[400] border-r border-[#ddd]">
                                                    <div className="flex flex-col h-[90px]">
                                                        <p className="border-b flex items-center justify-center h-full">배송수단</p>
                                                        <p className="flex items-center justify-center h-full">배송시간</p>
                                                    </div>
                                                </th>
                                                <th className="font-[400] border-r border-[#ddd]">
                                                    <div className="flex flex-col h-[90px]">
                                                        <p className="border-b flex items-center justify-center h-full">출발지고객명</p>
                                                        <p className="flex items-center justify-center h-full">도착지고객명</p>
                                                    </div>
                                                </th>
                                                <th className="font-[400] border-r border-[#ddd]">
                                                    <div className="flex flex-col h-[90px]">
                                                        <p className="border-b flex items-center justify-center h-full">출발지동명</p>
                                                        <p className="flex items-center justify-center h-full">도착지동명</p>
                                                    </div>
                                                </th>
                                                <th className="font-[400] border-r border-[#ddd]">
                                                    <div className="flex flex-col h-[90px]">
                                                        <p className="border-b flex items-center justify-center h-full">출발지주소</p>
                                                        <p className="flex items-center justify-center h-full">도착지주소</p>
                                                    </div>
                                                </th>
                                                <th className="font-[400] border-r border-[#ddd]">지급방법</th>
                                                <th className="font-[400] border-r border-[#ddd]">배송방법</th>
                                                <th className="font-[400] border-r border-[#ddd]">배송선택</th>
                                                <th className="font-[400] border-r border-[#ddd]">물품종류</th>
                                                <th className="font-[400] border-r border-[#ddd]">처리상태</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orderData && orderData?.data_list.length > 0 ? (
                                                <>
                                                    {orderData?.data_list.map(data => {
                                                        return (
                                                            <tr key={data.list_no} className="border-b border-black">
                                                                <td className="font-[400] border-r border-[#ddd] text-center px-2">
                                                                    <p className="truncate text-[#999999]">{data.w_date}</p>
                                                                </td>

                                                                <td className="font-[400] border-r border-[#ddd] text-center px-2">
                                                                    <Link
                                                                        to={`${data.list_no}`}
                                                                        className="max-w-full inline-block truncate bg-[#192030] text-white text-[14px] rounded-[5px] px-[12px] py-[7.5px]"
                                                                    >
                                                                        {data.c_name}
                                                                    </Link>
                                                                </td>

                                                                <td className="font-[400] border-r border-[#ddd] text-center">
                                                                    {data.c_dept_name}
                                                                </td>
                                                                <td className="font-[400] border-r border-[#ddd]">
                                                                    <div className="flex flex-col h-[90px]">
                                                                        <div className="border-b flex items-center justify-center h-full px-2">
                                                                            <p className="truncate">
                                                                                {kindArray.find(item => item.value === data.kind)?.label}
                                                                            </p>
                                                                        </div>
                                                                        <div className="flex items-center justify-center h-full px-2">
                                                                            <p className="truncate">{data.dtime}</p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="font-[400] border-r border-[#ddd]">
                                                                    <div className="flex flex-col h-[90px]">
                                                                        <div className="border-b flex items-center justify-center h-full px-2">
                                                                            <p className="truncate">{data.s_start}</p>
                                                                        </div>
                                                                        <div className="flex items-center justify-center h-full px-2">
                                                                            <p className="truncate">{data.dest_charge}</p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="font-[400] border-r border-[#ddd]">
                                                                    <div className="flex flex-col h-[90px]">
                                                                        <div className="border-b flex items-center justify-center h-full px-2">
                                                                            <p className="truncate">{data.start_dong}</p>
                                                                        </div>
                                                                        <div className="flex items-center justify-center h-full px-2">
                                                                            <p className="truncate">{data.dest_dong}</p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="font-[400] border-r border-[#ddd]">
                                                                    <div className="flex flex-col h-[90px]">
                                                                        <div className="border-b flex items-center justify-center h-full px-2">
                                                                            <p className="truncate">{data.start_location}</p>
                                                                        </div>
                                                                        <div className="flex items-center justify-center h-full px-2">
                                                                            <p className="truncate">{data.dest_location}</p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="font-[400] border-r border-[#ddd] text-center">
                                                                    {payGbnArray.find(item => item.value === data.pay_gbn)?.label}
                                                                </td>
                                                                <td className="font-[400] border-r border-[#ddd] text-center">
                                                                    <p className="truncate">
                                                                        {docArray.find(item => item.value === data.doc)?.label}
                                                                    </p>
                                                                </td>
                                                                <td className="font-[400] border-r border-[#ddd] text-center">
                                                                    {sfastArray.find(item => item.value === data.sfast)?.label}
                                                                </td>
                                                                <td className="font-[400] border-r border-[#ddd] text-center">
                                                                    {itemTypeArray.find(item => item.value === data.item_type)?.label}
                                                                </td>
                                                                <td className="font-[400] border-r border-[#ddd] text-center">
                                                                    {data.order_state === "Y" ? "완료" : "대기"}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </>
                                            ) : (
                                                <tr>
                                                    <td colSpan={12} className="text-center py-10">
                                                        내용이 없습니다.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                )}

                                <Pagination
                                    current={page}
                                    total={orderData?.total_count || 1}
                                    pageSize={Number(searchForm.limit)}
                                    onChange={newPage => {
                                        searchParams.set("page", String(newPage));
                                        setSearchParams(searchParams);
                                        // setSearchForm(prev => ({ ...prev, page: newPage }))
                                    }}
                                />

                                {/* <div className="flex justify-center items-center gap-2 mt-6">
                                    <button onClick={() => handleSetPage(1)}>
                                        <PageFirst />
                                    </button>
                                    <button onClick={() => handleSetPage(Math.max(1, page - 1))}>
                                        <PageBefore className="mr-7" />
                                    </button>
                                    {Array.from({ length: endPage - startPage + 1 }).map((_, i) => {
                                        const pageNum = startPage + i;
                                        return (
                                            <button
                                                key={pageNum}
                                                className={`px-3 py-1 rounded ${pageNum === page ? "bg-[#1B1C1E] text-white" : "text-black"}`}
                                                onClick={() => handleSetPage(pageNum)}
                                            >
                                                {pageNum}
                                            </button>
                                        );
                                    })}
                                    <button onClick={() => handleSetPage(Math.min(maxPage, page + 1))}>
                                        <PageBefore className="rotate-180 ml-7" />
                                    </button>
                                    <button onClick={() => handleSetPage(maxPage)}>
                                        <PageFirst className="rotate-180" />
                                    </button>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Toaster position="bottom-center" reverseOrder={false} />
        </>
    );
};

export default ConsoleExpressOrder;
